/* お申込人の同意事項 */
import React, { useState } from 'react';
import RowTemplate from '../atoms/RowTemplate';
import ShelfInShelf from '../molecules/ShelfInShelf';
import { Modal } from 'react-bootstrap';
import { http_status_code_list } from '../Const';

interface Props {
  id: string;
  label: string;
  need?: boolean;
  disabled: boolean;
  looks_inactive?: boolean;
  privacy: string; // 個人情報の取り扱いに関する同意日時
  not_antisocial_forces: string; // 反社会敵勢力等
  reception_id: number;
  setIsLoading: (flag: boolean) => void;
}

const ApplicantAgreement: React.FC<Props> = ({
  id,
  label,
  need,
  disabled,
  looks_inactive,
  privacy,
  not_antisocial_forces,
  reception_id,
  setIsLoading,
}) => {
  const [is_open, setIsOpen] = useState(false);
  const [show_error_popup, setShowErrorPopup] = useState(false);
  const [error_message, setErrorMessage] = useState('システムエラーが発生しました');

  // 同意文書のダウンロード処理
  const downloadDocument = () => {
    try {
      setIsLoading(true);
      //ファイルをダウンロードする。
      const url = `${location.origin}${process.env.MIX_MOCK_URL}/api/staff_download_document?r_id=${reception_id}`;
      const self_download_link = document.createElement('a');
      document.body.appendChild(self_download_link);
      // note 同意文のファイル名は固定
      self_download_link.download = 'ConsentForm.pdf';
      self_download_link.href = url;
      self_download_link.click();
      self_download_link.remove();
      URL.revokeObjectURL(url);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error(error);
      if (error.response.status === http_status_code_list.unauthorized) {
        // セッション切れの場合はログイン画面に遷移
        location.replace(error.response.data.url);
        return;
      }
      setShowErrorPopup(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <ShelfInShelf id={id} label={label} is_open={is_open} handleClick={() => setIsOpen(!is_open)}>
      <RowTemplate
        label="お借入の申込、保証委託の申込ならびに個人情報の取扱いに関する同意日時"
        need={need}
        disabled={disabled}
        looks_inactive={looks_inactive}
        show={true}
        content={<>{privacy}</>}
      />
      <RowTemplate
        label="反社会的勢力ではないことの表明・確約に関する同意日時"
        need={need}
        disabled={disabled}
        looks_inactive={looks_inactive}
        show={true}
        content={<>{not_antisocial_forces}</>}
      />
      <div className="text-center">
        <a
          className="btn btn-bg-white btn-outline-success btn-text-color false"
          onClick={downloadDocument}
        >
          同意文書のダウンロード
        </a>
      </div>
      {/* エラー表示 */}
      <Modal
        show={show_error_popup}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => {}}
      >
        <Modal.Body>{error_message}</Modal.Body>
        <Modal.Footer>
          <a
            className="btn btn-success"
            onClick={() => {
              setShowErrorPopup(false);
            }}
          >
            OK
          </a>
        </Modal.Footer>
      </Modal>
    </ShelfInShelf>
  );
};

export default ApplicantAgreement;
